import { render, staticRenderFns } from "./FrontTitle.vue?vue&type=template&id=4333e8b4&scoped=true&"
import script from "./FrontTitle.vue?vue&type=script&lang=js&"
export * from "./FrontTitle.vue?vue&type=script&lang=js&"
import style0 from "./FrontTitle.vue?vue&type=style&index=0&id=4333e8b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333e8b4",
  null
  
)

export default component.exports